




















import { Component, Vue } from 'vue-property-decorator';
import Classroom from '@/services/Classroom';

@Component
export default class CreateClassroom extends Vue {
  classroom = {
    name: '',
  };

  public mounted() {
    (this.$refs.first as HTMLInputElement).focus();
  }

  async createClassroom(e: any) {
    e.preventDefault();

    if (this.classroom.name) {
      const uuid = await Classroom.createClassRoom(this.classroom.name);
      this.closeModal();
      if (uuid) {
        await this.$router.push({ name: 'TeacherClass', params: { id: uuid } });
      }
    }
  }

  closeModal() {
    this.$parent.$emit('close-modal');
  }
}
